import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as stateInterface from "./state";
import * as sagaInterface from "./saga";

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void
  ? I
  : never;

type ActionSources = typeof stateInterface & typeof sagaInterface;

type ActionCreatorGroups = {
  [K in keyof ActionSources]: K extends `${string}ActionCreators` ? ActionSources[K] : never;
}[keyof ActionSources];

type AllActionCreators = UnionToIntersection<ActionCreatorGroups>;

const actionInterface = {
  ...stateInterface,
  ...sagaInterface,
};

const actionCreators = Object.keys(actionInterface).reduce((result, key) => {
  const typedKey = key as keyof ActionSources;
  const current = typedKey.endsWith("ActionCreators") ? actionInterface[typedKey] : {};

  return {
    ...current,
    ...result,
  };
}, {}) as AllActionCreators;

export const useCreateDispatchActions = () => {
  const dispatch = useDispatch();
  return bindActionCreators(
    {
      ...actionCreators,
    },
    dispatch,
  );
};
